import {
  type HrRealtimeStats,
  type HrEmployeesPayload,
  fetchHrDashboardSafe as fetchHrDashboardSafeApi,
  fetchHrEmployeesPageSafe as fetchHrEmployeesPageSafeApi,
  fetchHrRealtimeStats as fetchHrRealtimeStatsData,
} from '../../api/hr';

export type { HrRealtimeStats, HrEmployeesPayload };

export async function fetchHrRealtimeStats(): Promise<HrRealtimeStats> {
  return fetchHrRealtimeStatsData();
}

export async function fetchHrDashboardSafe(): Promise<unknown | null> {
  return fetchHrDashboardSafeApi();
}

export async function fetchHrEmployeesPageSafe(): Promise<HrEmployeesPayload> {
  return fetchHrEmployeesPageSafeApi();
}
